<template>
  <div class="reward-form">
    <div class="col-xs-12">
      <h1 class="text-uppercase">step 5: Reward Items</h1>
      <br>
    </div>
    <div class="col-sm-5">
      <input
        v-model="currentItem.name"
        type="text"
        class="form-control admin-form-control input-lg"
        placeholder="Item Name">
    </div>
    <div class="col-sm-2">
      <input
        v-model.number="currentItem.points"
        type="number"
        class="form-control admin-form-control input-lg"
        placeholder="Points Price">
    </div>
    <div class="clearfix"></div>
    <div class="col-sm-4">
      <select multiple v-model="currentItem.sizes" class="form-control admin-form-control input-lg">
        <option disabled>Sizes</option>
        <option v-for="(size, index) in itemSizes" :key="index" :value="size">{{ size }}</option>
      </select>
    </div>
    <div class="col-sm-4">
      <select multiple v-model="currentItem.colors" class="form-control admin-form-control input-lg">
        <option disabled>Colors</option>
        <option v-for="(color, index) in itemColors" :key="index" :value="JSON.stringify(color)">{{ toReadable(color.name) }}</option>
      </select>
    </div>
    <div class="clearfix"></div>
    <div class="col-sm-6">
      <div class="custom-sizes custom-group-wrapper admin-form-control">
        <button class="btn btn-sm clickable link-hover" @click="addSize">Add Size</button>
        <div
          v-for="(size, index) in currentItem.customSizes"
          class="custom-field-group"
          :key="index"
          >
          <input
            type="text"
            v-model="currentItem.customSizes[index]"
            class="col-md-11"
            placeholder="Size">
          <div class="col-md-1">
            <span class="glyphicon glyphicon-trash" @click="removeSize(index)"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="custom-sizes custom-group-wrapper admin-form-control">
        <button class="btn btn-sm clickable link-hover" @click="addColor">Add Color</button>
        <div
          v-for="(color, index) in currentItem.customColors"
          class="custom-field-group"
          :key="index"
          >
          <input
            type="text"
            v-model="color.name"
            class="col-md-5"
            placeholder="Color">
          <input
            type="text"
            v-model="color.hex"
            class="col-md-5 col-md-offset-1"
            placeholder="Color Code">
          <div class="col-md-1">
            <span class="glyphicon glyphicon-trash" @click="removeColor(index)"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-12">
      <label for="">Description</label>
      <editor
          name="appendedOutput"
          :api-key="editorKey"
          :init="tinyOptions"
          v-model="currentItem.description"
        ></editor>
      <!-- <textarea v-model="currentItem.description" class="form-control admin-form-control input-lg" rows="5" placeholder="Description"></textarea> -->
    </div>

    <div class="clearfix"></div>
    <div class="col-sm-4">
      <input
        id=""
        type="file"
        name=""
        ref="imageFile"
        @change="uploadToS3"
        style="display:none">
      <a
        href="#"
        type="button"
        :class="uploadImgClasses"
        @click.prevent="triggerInput">
        Upload Image&nbsp; <span class="glyphicon glyphicon-open glyphicon "></span>
      </a>
    </div>

    <div class="col-sm-4">
      <a
        href="#"
        type="button"
        :class="saveBtnClasses"
        @click.prevent="addItem">
        Save/Add Item&nbsp; <span class="glyphicon glyphicon-plus glyphicon "></span>
      </a>
    </div>
  </div>
</template>

<script>
import S3 from '../../_helpers/awsS3'
import Editor from '@tinymce/tinymce-vue'
const crypto = require('crypto')
const _ = require('lodash')

export default {
  name: 'RewardItemForm',
  components: {
    editor: Editor
  },
  data () {
    return {
      loading: false,
      file: null,
      rewardItems: [],
      currentItem: {
        name: null,
        points: null,
        sizes: [],
        customSizes: [],
        colors: [],
        customColors: [],
        description: '',
        image: {
          url: null,
          fileName: null,
          randomString: null,
          imageKey: null
        }
      },
      itemSizes: [
        'X-Small',
        'Small',
        'Medium',
        'Large',
        'X-Large'
      ],
      itemColors: [
        { name: 'Red', hex: 'f44336' },
        { name: 'Orange', hex: 'f39500' },
        { name: 'Yellow', hex: 'ffeb3b' },
        { name: 'Green', hex: '4caf50' },
        { name: 'Blue', hex: '2949fd' },
        { name: 'Purple', hex: '673ab7' },
        { name: 'Black', hex: '000' },
        { name: 'White', hex: 'fff' }
      ],
      editorKey: '7bb76f8qmjwrxz0hn4kh6gyt3bs2fyk3pv7xavth6kcn3460',
      tinyOptions: {
        body_class: 'form-control admin-form-control input-lg',
        height: 200,
        menubar: false,
        toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright justify | numlist bullist outdent indent | forecolor | removeformat',
        plugins: ['lists']
      }
    }
  },
  computed: {
    saveBtnClasses () {
      const common = 'form-but btn admin-btn-primary btn-lg btn-block text-uppercase'
      return this.loading ? common + ' disabled' : common
    },
    uploadImgClasses () {
      const common = 'form-but btn btn-default btn-lg btn-block text-uppercase'
      return this.currentItem.image.url ? common + ' disabled' : common
    }
  },
  methods: {
    generateRandomString () {
      return crypto.randomBytes(20).toString('hex')
    },
    triggerInput (event) {
      this.$refs.imageFile.click()
    },
    uploadToS3 () {
      this.loading = true
      this.$bus.emit('global-load', { load: true, message: 'Loading image', env: 'admin' })
      const file = this.$refs.imageFile.files[0]
      if (!file) {
        return
      }
      this.file = file
      this.currentItem.image.fileName = file.name
      this.currentItem.image.randomString = this.generateRandomString()
      const albumPhotosKey = encodeURIComponent('rewardItems') + '/'
      this.currentItem.image.imageKey = `${albumPhotosKey}${this.currentItem.image.randomString}-${this.currentItem.image.fileName}`
      S3.uploadToS3(this.currentItem.image.imageKey, this.file)
        .then(result => {
          this.currentItem.image.url = result.Location
          this.$bus.emit('global-load', { load: false })
          this.loading = false
          alert('Submission successful.')
        })
        .catch(err => {
          console.log(err.message)
          this.$bus.emit('global-load', { load: false })
          alert('Submission error, please try again. ', err.message)
        })
    },
    addItem () {
      this.rewardItems.push(Object.assign({}, this.currentItem))
      this.$emit('input', this.rewardItems)
      // reset current item
      Object.assign(this.currentItem, this.$options.data().currentItem)
    },
    toReadable (word) {
      let words = word.match(/[A-Za-z][a-z]*/g) || []
      return words.map(word => {
        return word.charAt(0).toUpperCase() + word.substring(1)
      }).join(' ')
    },
    addColor () {
      this.currentItem.customColors.push({ name: '', hex: '' })
    },
    removeColor (index) {
      let copy = _.cloneDeep(this.currentItem.customColors)
      copy.splice(index, 1)
      this.currentItem.customColors = copy
    },
    addSize () {
      this.currentItem.customSizes.push('')
    },
    removeSize (index) {
      let copy = _.cloneDeep(this.currentItem.customSizes)
      copy.splice(index, 1)
      this.currentItem.customSizes = copy
    }
  }
}
</script>

<style scoped>
.custom-group-wrapper {
  box-shadow: 0 0px 10px 0px rgba(0,0,0,.35);
  padding: 10px 16px;
  border-radius: 6px;
  margin: 15px 0px;
  min-height: 114px;
  max-height: 175px;
  overflow-y: auto;
}

.custom-field-group {
  display: flex;
  align-items: center;
  padding: 5px;
  border: 1px solid #eae9e9;
  border-radius: 5px;
}

.custom-field-group input {
  font-size: 18px;
}

.custom-field-group:not(:last-child) {
  margin-bottom: 5px;
}

.custom-field-group input {
  border: none;
  border-bottom: 1px solid #efefef;
}

.link-hover:hover {
  font-weight: bold;
  text-decoration: underline;
}
</style>
